export default __webpack_public_path__ + "static/media/dotted-3.b1072ee0.webp";